<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <!-- Card -->
        <!-- <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <div class="mb-2">
                  <span>Training Monitoring</span>
                 
                </div>

                <p class="text-muted mb-md-0">
                  This is Training Monitoring menu
                </p>
              </div>
            </div>
          </div>
        </div> -->
        <!-- My IDP dll -->
        <div class="card mt-5">
          <div class="card-header">
            <span class="mt-3 fs-2">IDP Management - Structured Learning</span>
          </div>
          <div class="row px-4">
            <!-- <div class="col-6">
              <v-select
                :options="['Dummy 1', 'Dummy 2']"
                class="mt-4"
                placeholder="Filter by Bussiness Unit"></v-select>
            </div>
            <div class="col-6">
              <v-select
                :options="['Dummy 1', 'Dummy 2']"
                class="mt-4"
                placeholder="Filter by Employee Name"></v-select>
            </div>
            <div class="col-6">
              <v-select
                :options="['Dummy 1', 'Dummy 2']"
                class="mt-4"
                placeholder="Filter by Status"></v-select>
            </div> -->
            <div class="card-body">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-2">
                    <h5 class="fw-bold mt-5">Company</h5>
                  </div>
                  <div class="col-4">
                    <v-select
                      v-model="bodySearch.company"
                      :options="bussinessUnit"
                      class="mt-4"
                      placeholder="Select Company"
                      @input="onBussinessUnitSelected('company')">
                    </v-select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-2">
                    <h5 class="fw-bold mt-5">Directorate</h5>
                  </div>
                  <div class="col-4">
                    <v-select
                      :disabled="bodySearch.company ? false : true"
                      v-model="bodySearch.directorate"
                      :options="bussinessUnit2"
                      class="mt-4"
                      placeholder="Select Directorate"
                      @input="onBussinessUnitSelected('dir')">
                    </v-select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-2">
                    <h5 class="fw-bold mt-5">Division</h5>
                  </div>
                  <div class="col-4">
                    <v-select
                      v-model="bodySearch.division"
                      :disabled="
                        bodySearch.company && bodySearch.directorate
                          ? false
                          : true
                      "
                      :options="bussinessUnit3"
                      class="mt-4"
                      placeholder="Select Division"
                      @input="onBussinessUnitSelected('div')">
                    </v-select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-2">
                    <h5 class="fw-bold mt-5">Department</h5>
                  </div>
                  <div class="col-4">
                    <v-select
                      v-model="bodySearch.department"
                      :disabled="
                        bodySearch.company &&
                        bodySearch.directorate &&
                        bodySearch.division
                          ? false
                          : true
                      "
                      :options="bussinessUnit4"
                      class="mt-4"
                      placeholder="Select Department"
                      @input="onBussinessUnitSelected('dept')">
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 mt-5">
                <div class="row mt-4">
                  <div class="col-lg-2">
                    <p class="small mt-2">
                      <strong>Name</strong>
                    </p>
                  </div>
                  <div class="col-4">
                    <!-- {{listKaryawan}} -->
                    <v-select
                      v-model="employee"
                      :options="listKaryawan"
                      :reduce="(e) => e"
                      label="employee_name"
                      placeholder="Select Employee">
                    </v-select>
                    <!-- @input="selectEmployee" -->
                  </div>
                </div>
                <!-- <div class="row mt-3">
                <div class="col-lg-2">
                  <p class="small mt-2">
                    <strong>NIK</strong>
                  </p>
                </div>
                <div class="col-4">
                  {{ nik || "-" }}
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-lg-2">
                  <p class="small mt-2">
                    <strong>Position</strong>
                  </p>
                </div>
                <div class="col-4">
                  {{ position || "-" }}
                </div>
              </div> -->
              </div>
            </div>
            <div class="col-12">
              <div class="d-flex justify-content-end align-items-center mt-3">
                <b-button
                  class="btn btn-primary mx-2"
                  variant="primary"
                  @click="selectEmployee">
                  <span class="fe fe-search"></span>
                  Search
                </b-button>
                <b-button
                  v-if="currentTab === 0"
                  class="btn btn-primary mx-2"
                  variant="primary"
                  @click="bulkApproved">
                  <span class="fe fe-save"></span>
                  Bulk Approved
                </b-button>
              </div>
            </div>
          </div>
          <div class="px-4 mt-3">
            <b-tabs justified v-model="currentTab">
              <b-tab title="External Certificate Review">
                <div class="table-responsive">
                  <div v-if="isLoading" class="text-center my-4">
                    <span
                      class="spinner-border"
                      role="status"
                      aria-hidden="true"></span>
                    <p>Loading...</p>
                  </div>

                  <table
                    v-else
                    class="table table-sm table-bordered table-nowrap mt-4">
                    <thead>
                      <tr class="">
                        <th rowspan="2">Competency</th>
                        <th rowspan="2">Training</th>
                        <!-- <th rowspan="2">Learning Type</th> -->
                        <th rowspan="2">Provider</th>
                        <th rowspan="2">Learning Method</th>
                        <th rowspan="2">Price</th>
                        <th rowspan="2">Employee Name</th>
                        <!-- <th rowspan="2">Total Price</th> -->
                        <th rowspan="2">Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="inReview && inReview.length">
                      <tr v-for="(item, index) in inReview" :key="index">
                        <td class="">
                          {{ item.all_competency }}
                        </td>
                        <td class="">
                          {{ item.training_title }}
                        </td>
                        <!-- <td class="">
                    {{ item.training_type }}
                  </td> -->
                        <td class="">
                          {{ item.training_provider }}
                        </td>
                        <td class="">
                          {{ item.training_method }}
                        </td>
                        <td class="text-center" v-if="item.price !== null">
                          {{ formatPrice(item.training_price, item.training_currency) }}
                        </td>
                        <td v-else></td>
                        <td class="text-center">
                          {{ item.employee_name }}
                        </td>
                        <!-- <td class="text-center" v-if="item.price !== null">
                    {{ formatPrice(item.total_price) }}
                  </td>
                  <td v-else></td> -->
                        <td class="text-center">
                          <button
                            class="btn btn-sm btn-info mx-2"
                            @click="viewDetailsReview(item)">
                            <span class="fe fe-eye"></span>
                          </button>

                          <button
                            v-if="item.status === 'completed'"
                            class="btn btn-sm btn-primary mx-2">
                            <span class="fe fe-download"></span>
                          </button>
                          <button
                            v-if="item.status === 'completed'"
                            class="btn btn-sm btn-info mx-2">
                            <span class="fe fe-upload"></span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td class="text-center" colspan="12">
                          No Data Available
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <p class="mt-3">
              <i>
                Note: If checked, it will be submitted. If unchecked, it will be
                rejected.
              </i>
            </p> -->
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL HERE -->
    <!-- Modal Enroll -->
    <!-- <b-modal
      v-model="isEnrollModalVisible"
      title="Create Event"
      size="lg"
      hide-footer
      @hide="clearEnrollModal">
      <div class="form-group">
        <div class="row">
          <div class="col-6">
            <label class="form-label">Training Title</label>
            <input
              v-model="bodyEnroll.trainingTitle"
              type="text"
              class="form-control"
              placeholder="Training Title"
              disabled />
          </div>
          <div class="col-6">
            <label class="form-label">Training Provider</label>
            <input
              v-model="bodyEnroll.trainingProvider"
              type="text"
              class="form-control"
              placeholder="Training Provider"
              disabled />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Method</label>
            <v-select
              v-model="bodyEnroll.trainingMethod"
              :options="dataTrainingMethod"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Method" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Price</label>
            <input
              v-model="bodyEnroll.price"
              type="number"
              class="form-control"
              placeholder="Price" />
          </div>
          <div class="col-12 mt-4">
            <label class="form-label">Location</label>
            <input
              v-model="bodyEnroll.location"
              type="text"
              class="form-control"
              placeholder="Location" />
          </div>
        </div>
        <div class="mt-4">
          <b-button @click="showScheduleModal" variant="primary"
            ><span class="fe fe-plus"></span>Add Schedule</b-button
          >
        </div>

        <div class="mt-4">
          <h4>Schedule</h4>
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th style="width: 50px">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="scheduleList.length === 0">
                <td class="text-center" colspan="4">No Data Available</td>
              </tr>
              <tr v-else v-for="(item, index) in scheduleList" :key="index">
                <td>{{ item.date }}</td>
                <td>{{ item.startTime }}</td>
                <td>{{ item.endTime }}</td>
                <td>
                  <button
                    @click="removeSchedule(index)"
                    class="btn btn-sm btn-danger">
                    <span class="fe fe-trash"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="mt-4">
          <h4>Participants</h4>
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Position</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="selectedParticipants.length === 0">
                <td class="text-center" colspan="2">No Data Available</td>
              </tr>
              <tr
                v-else
                v-for="(participant, index) in selectedParticipants"
                :key="index">
                <td>{{ participant.employee_name }}</td>
                <td>{{ participant.employee_position }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <b-modal
        v-model="isScheduleModalVisible"
        title="Add Schedule"
        size="lg"
        hide-footer
        @hide="clearScheduleModal">
        <div class="form-group">
          <div class="row">
            <div class="col-6">
              <p class="form-label">Date</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.date"
                type="date"
                format="DD-MM-YYYY"
                placeholder="Select Date" />
            </div>
            <div class="col-6">
              <p class="form-label">Start Time</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.startTime"
                type="time"
                format="HH:mm"
                placeholder="Select Start Time" />
            </div>
            <div class="col-6 mt-4">
              <p class="form-label">End Time</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.endTime"
                type="time"
                format="HH:mm"
                placeholder="Select End Time" />
            </div>
          </div>
          <div class="mt-4">
            <b-button class="float-end" @click="addSchedule" variant="primary"
              >Add</b-button
            >
          </div>
        </div>
      </b-modal>
      <div class="mt-4 float-end">
        <b-button
          class="mr-3"
          @click="isEnrollModalVisible = false"
          variant="secondary"
          >Cancel</b-button
        >
        <b-button @click="submitEnroll" variant="primary"
          ><span class="fe fe-save mr-1"></span>Submit</b-button
        >
      </div>
    </b-modal> -->
    <!-- Modal Create Event -->
    <b-modal
      v-model="isEnrollModalVisible"
      title="Create Event"
      size="lg"
      hide-footer
      @hide="clearEnrollModal">
      <!-- {{ selectedRow }} -->
      <div class="form-group">
        <div class="row">
          <div class="col-6">
            <label class="form-label">Training Title</label>
            <input
              v-model="bodyEnroll.trainingTitle"
              type="text"
              class="form-control"
              placeholder="Training Title"
              disabled />
          </div>
          <div class="col-6">
            <label class="form-label">Training Provider</label>
            <input
              v-model="bodyEnroll.trainingProvider"
              type="text"
              class="form-control"
              placeholder="Training Provider"
              disabled />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Method</label>
            <v-select
              v-model="bodyEvent.trainingMethod"
              :options="dataTrainingMethod"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Method" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Price</label>
            <input
              v-model="bodyEvent.price"
              type="number"
              class="form-control"
              placeholder="Price" />
          </div>
          <div class="col-12 mt-4">
            <label class="form-label">Location</label>
            <input
              v-model="bodyEvent.location"
              type="text"
              class="form-control"
              placeholder="Location" />
          </div>
          <div class="col-12 mt-4">
            <label class="form-label">Quota</label>
            <input
              v-model="bodyEvent.quota"
              type="number"
              class="form-control"
              placeholder="Quota" />
          </div>
        </div>
        <div class="mt-4">
          <b-button @click="showScheduleModal" variant="primary"
            ><span class="fe fe-plus"></span>Add Schedule</b-button
          >
        </div>

        <!-- Schedule Table -->
        <div class="mt-4">
          <h4>Schedule</h4>
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th style="width: 50px">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="scheduleList.length === 0">
                <td class="text-center" colspan="4">No Data Available</td>
              </tr>
              <tr v-else v-for="(item, index) in scheduleList" :key="index">
                <td>{{ item.date }}</td>
                <td>{{ item.startTime }}</td>
                <td>{{ item.endTime }}</td>
                <td>
                  <button
                    @click="removeSchedule(index)"
                    class="btn btn-sm btn-danger">
                    <span class="fe fe-trash"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Participants Table -->
        <!-- <div class="mt-4">
          <h4>Participants</h4>
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Position</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="selectedParticipants.length === 0">
                <td class="text-center" colspan="2">No Data Available</td>
              </tr>
              <tr
                v-else
                v-for="(participant, index) in selectedParticipants"
                :key="index">
                <td>{{ participant.employee_name }}</td>
                <td>{{ participant.employee_position }}</td>
              </tr>
            </tbody>
          </table>
        </div> -->
      </div>

      <!-- Modal Schedule -->
      <b-modal
        v-model="isScheduleModalVisible"
        title="Add Schedule"
        size="lg"
        hide-footer
        @hide="clearScheduleModal">
        <div class="form-group">
          <div class="row">
            <div class="col-6">
              <p class="form-label">Date</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.date"
                type="date"
                format="DD-MM-YYYY"
                placeholder="Select Date" />
            </div>
            <div class="col-6">
              <p class="form-label">Start Time</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.startTime"
                type="time"
                format="HH:mm"
                placeholder="Select Start Time" />
            </div>
            <div class="col-6 mt-4">
              <p class="form-label">End Time</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.endTime"
                type="time"
                format="HH:mm"
                placeholder="Select End Time" />
            </div>
          </div>
          <div class="mt-4">
            <b-button class="float-end" @click="addSchedule" variant="primary"
              >Add</b-button
            >
          </div>
        </div>
      </b-modal>
      <div class="mt-4 float-end">
        <b-button
          class="mr-3"
          @click="isEnrollModalVisible = false"
          variant="secondary"
          >Cancel</b-button
        >
        <b-button @click="submitEvent" variant="primary"
          ><span class="fe fe-save mr-1"></span>Submit</b-button
        >
      </div>
    </b-modal>
    <!-- Modal Edit Event -->
    <b-modal
      v-model="isEditEvent"
      title="Edit Event"
      size="lg"
      hide-footer
      @hide="clearEnrollModal">
      <!-- {{ selectedRow }} -->
      <div class="form-group">
        <div class="row">
          <div class="col-6">
            <label class="form-label">Training Title</label>
            <input
              v-model="bodyEnroll.trainingTitle"
              type="text"
              class="form-control"
              placeholder="Training Title"
              disabled />
          </div>
          <div class="col-6">
            <label class="form-label">Training Provider</label>
            <input
              v-model="bodyEnroll.trainingProvider"
              type="text"
              class="form-control"
              placeholder="Training Provider"
              disabled />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Method</label>
            <v-select
              v-model="bodyEditEvent.trainingMethod"
              :options="dataTrainingMethod"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Method" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Price</label>
            <input
              v-model="bodyEditEvent.price"
              type="number"
              class="form-control"
              placeholder="Price" />
          </div>
          <div class="col-12 mt-4">
            <label class="form-label">Location</label>
            <input
              v-model="bodyEditEvent.location"
              type="text"
              class="form-control"
              placeholder="Location" />
          </div>
          <div class="col-12 mt-4">
            <label class="form-label">Quota</label>
            <input
              v-model="bodyEditEvent.quota"
              type="number"
              class="form-control"
              placeholder="Quota" />
          </div>
        </div>
        <div class="mt-4">
          <b-button @click="showScheduleModal" variant="primary"
            ><span class="fe fe-plus"></span>Add Schedule</b-button
          >
        </div>

        <!-- Schedule Table -->
        <div class="mt-4">
          <h4>Schedule</h4>
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th style="width: 50px">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="scheduleList.length === 0">
                <td class="text-center" colspan="4">No Data Available</td>
              </tr>
              <tr v-else v-for="(item, index) in scheduleList" :key="index">
                <td>{{ item.date }}</td>
                <td>{{ item.startTime }}</td>
                <td>{{ item.endTime }}</td>
                <td>
                  <button
                    @click="removeSchedule(index)"
                    class="btn btn-sm btn-danger">
                    <span class="fe fe-trash"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Participants Table -->
        <!-- <div class="mt-4">
          <h4>Participants</h4>
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Position</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="selectedParticipants.length === 0">
                <td class="text-center" colspan="2">No Data Available</td>
              </tr>
              <tr
                v-else
                v-for="(participant, index) in selectedParticipants"
                :key="index">
                <td>{{ participant.employee_name }}</td>
                <td>{{ participant.employee_position }}</td>
              </tr>
            </tbody>
          </table>
        </div> -->
      </div>

      <!-- Modal Schedule -->
      <b-modal
        v-model="isScheduleModalVisible"
        title="Add Schedule"
        size="lg"
        hide-footer
        @hide="clearScheduleModal">
        <div class="form-group">
          <div class="row">
            <div class="col-6">
              <p class="form-label">Date</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.date"
                type="date"
                format="DD-MM-YYYY"
                placeholder="Select Date" />
            </div>
            <div class="col-6">
              <p class="form-label">Start Time</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.startTime"
                type="time"
                format="HH:mm"
                placeholder="Select Start Time" />
            </div>
            <div class="col-6 mt-4">
              <p class="form-label">End Time</p>
              <v-date-picker
                style="width: 350px"
                v-model="schedule.endTime"
                type="time"
                format="HH:mm"
                placeholder="Select End Time" />
            </div>
          </div>
          <div class="mt-4">
            <b-button class="float-end" @click="addSchedule" variant="primary"
              >Add</b-button
            >
          </div>
        </div>
      </b-modal>
      <div class="mt-4 float-end">
        <b-button class="mr-3" @click="isEditEvent = false" variant="secondary"
          >Cancel</b-button
        >
        <b-button @click="editEvent" variant="primary"
          ><span class="fe fe-save mr-1"></span>Update</b-button
        >
      </div>
    </b-modal>

    <!-- Modal Detail -->
    <b-modal
      v-model="isModalVisible"
      title="Detail View"
      size="xl"
      hide-footer
      @hide="clearSelectedRow">
      <b-card>
        <b-card-body>
          <b-row>
            <b-col md="4">
              <b-card-title>Title</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.training_name
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="4">
              <b-card-title>Training Type</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.training_type
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="4">
              <b-card-title>Training Method</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.training_method
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" class="mt-4">
              <b-card-title>Provider</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.training_provider
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="4" class="mt-4">
              <b-card-title>Price</b-card-title>
              <b-card-text v-if="selectedRow">{{
                formatPrice(selectedRow.training_price)
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="4" class="mt-4">
              <b-card-title>Total Price</b-card-title>
              <b-card-text v-if="selectedRow">{{
                formatPrice(selectedRow.total_price)
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <!-- {{ selectedRow }} -->
          <h3 class="mt-5">Batch List</h3>
          <div class="table-responsive">
            <table class="table table-sm table-bordered table-nowrap mt-4">
              <thead>
                <tr class="">
                  <th rowspan="2">Batch</th>
                  <th rowspan="2">Penyelenggara</th>
                  <th rowspan="2">Quota</th>
                  <th rowspan="2">Remaining Quota</th>
                  <th rowspan="2">Used Quota</th>
                  <th rowspan="2">Status</th>
                  <th class="text-center" rowspan="2">Action</th>
                </tr>
              </thead>
              <tbody v-if="eventList.length > 0">
                <tr v-for="(item, index) in eventList" :key="index">
                  <td class="">
                    {{ item.batch }}
                  </td>
                  <td>{{ item.penyelenggara || '-' }}</td>
                  <td class="">
                    {{ item.quota }}
                  </td>
                  <td class="">
                    {{ item.remaining_quota }}
                  </td>
                  <td class="">
                    {{ item.used_quota }}
                  </td>
                  <td class="text-center">
                    <h2>
                      <span :class="getBadgeStatusStructured(item.status)">
                        {{ capitalizeStatus(item.status) }}
                      </span>
                    </h2>
                  </td>
                  <td class="text-center">
                    <button
                      v-if="item.status != 'active'"
                      class="btn btn-sm btn-warning mx-1 my-1"
                      @click="showEditEvent(item)">
                      <span class="fe fe-edit"></span>
                    </button>
                    <button
                      class="btn btn-sm btn-danger mx-1 my-1"
                      @click="deleteEvent(item)">
                      <span class="fe fe-trash"></span>
                    </button>
                  </td>

                  <!-- <td class="">
                    {{ item.score }}
                  </td>
                  <td class="">
                    {{ item.certificate }}
                  </td> -->
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="12">No Data Available</td>
                </tr>
              </tbody>
            </table>
            <div class="float-end mt-4">
              <b-button @click="showCreateEvent()" variant="primary">
                <span class="fe fe-plus"></span>
                Create Event
              </b-button>
            </div>
          </div>
          <!-- <h3 class="mt-5">Participant List</h3>
          <div class="table-responsive">
            <table class="table table-sm table-bordered table-nowrap mt-4">
              <thead>
                <tr class="">
                  <th rowspan="2"></th>
                  <th rowspan="2">NIK</th>
                  <th rowspan="2">Employee Name</th>
                  <th rowspan="2">Position</th>
                  <th rowspan="2">Status</th>
                  <th rowspan="2">Score</th>
                  <th rowspan="2">Certificate</th>
                </tr>
              </thead>
              <tbody v-if="selectedRow && selectedRow.participants.length">
                <tr
                  v-for="(item, index) in selectedRow.participants"
                  :key="index">
                  <td class="">
                    <input
                      type="checkbox"
                      v-if="item.status === 'approved'"
                      v-model="selectedRows"
                      :value="item.id" />
                  </td>
                  <td class="">
                    {{ item.nik }}
                  </td>
                  <td class="">
                    {{ item.employee_name }}
                  </td>
                  <td class="">
                    {{ item.employee_position }}
                  </td>
                  <td class="text-center">
                    <h3>
                      <span :class="getBadgeStatusStructured(item.status)">
                        {{ capitalizeStatus(item.status) }}
                      </span>
                    </h3>
                  </td>
                  <td class="">
                    {{ item.score }}
                  </td>
                  <td class="">
                    {{ item.certificate }}
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="12">No Data Available</td>
                </tr>
              </tbody>
            </table>
            <div class="float-end mt-4">
              <b-button
                v-if="
                  selectedRow &&
                  selectedRow.participants.some(
                    (participant) => participant.status !== 'enrolled'
                  )
                "
                @click="showCreateEvent()"
                variant="primary">
                <span class="fe fe-rotate-ccw"></span>
                Enroll
              </b-button>
            </div>
          </div> -->
        </b-card-body>
      </b-card>
    </b-modal>

    <!-- Modal Detail Review -->
    <b-modal
      v-model="isModalReview"
      title="Detail View"
      size="xl"
      hide-footer
      @hide="clearSelectedRow">
      <b-card>
        <b-card-body>
          <b-row>
            <b-col md="4">
              <b-card-title>Title</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.training_title
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="4">
              <b-card-title>Training Type</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.training_type
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="4">
              <b-card-title>Training Method</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.training_method
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" class="mt-4">
              <b-card-title>Provider</b-card-title>
              <b-card-text v-if="selectedRow">{{
                selectedRow.training_provider
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="4" class="mt-4">
              <b-card-title>Price</b-card-title>
              <b-card-text v-if="selectedRow">{{
                formatPrice(selectedRow.training_price, selectedRow.training_currency)
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row md="4" class="mt-4" v-if="selectedRow">
            <b-col v-if="selectedRow.certificate">
              <b-card-title>Certificate</b-card-title>
              <img
                :src="certificateUrl"
                :style="{ width: '300px', height: 'auto' }"
                alt="Certificate"
                class="img-fluid" />
              <!-- <b-button
                class="btn btn-primary"
                variant="primary"
                @click="downloadCertificate()">
                <span class="fe fe-download"></span>
                Download Certificate
              </b-button> -->
            </b-col>
          </b-row>
          <b-button
            variant="primary"
            class="float-end"
            @click="completeReview(item)">
            <span class="fe fe-check-circle"></span> Complete
          </b-button>
          <!-- {{ selectedRow }} -->
        </b-card-body>
      </b-card>
    </b-modal>

    <!-- Modal Add Training -->
    <b-modal
      ref="modalTrainingAspiration"
      id="modal-training-aspiration"
      title="Buat Pelatihan Aspiration"
      hide-footer
      size="xl"
      centered>
      <div class="form-group">
        <div class="row">
          <!-- Bagian 1 -->
          <div class="col-6">
            <label class="form-label"
              >Competency
              <span class="text-danger"
                >(* Proficiency level is below standard)</span
              ></label
            >
            <v-select
              v-model="bodyAdd.competency"
              :options="dataCompetency"
              label="competency"
              :reduce="(e) => e.competency_id"
              placeholder="Select Competency" />
          </div>
          <div class="col-6">
            <label class="form-label">Provider</label>
            <v-select
              v-model="bodyAdd.provider"
              :options="dataProvider"
              label="name"
              @input="selectProvider"
              :reduce="(e) => e.id"
              placeholder="Select Provider" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Provider Name</label>
            <input
              v-model="bodyAdd.providerName"
              type="text"
              class="form-control"
              placeholder="Provider Name" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Address</label>
            <input
              type="text"
              v-model="bodyAdd.address"
              class="form-control"
              placeholder="Address" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Website</label>
            <input
              type="text"
              v-model="bodyAdd.websiteProvider"
              class="form-control"
              placeholder="Website" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Contact Person</label>
            <input
              type="text"
              v-model="bodyAdd.contactPerson"
              class="form-control"
              placeholder="Contact Person" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Email</label>
            <input
              type="text"
              v-model="bodyAdd.email"
              class="form-control"
              placeholder="Email" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Phone</label>
            <input
              type="number"
              class="form-control"
              v-model="bodyAdd.phone"
              placeholder="Phone" />
          </div>

          <!-- Bagian 2 -->
          <div class="col-6 mt-4">
            <label for=""
              >Training
              <span class="text-danger">(* Search Training If Exist)</span>
            </label>
            <v-select
              v-model="selectedLearning"
              :options="dataTraining"
              label="title"
              @input="selectTraining"
              @search="searchTraining"
              placeholder="Search Training">
              <!-- <span slot="no-options">Search Learning Title</span> -->
            </v-select>
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Name</label>
            <input
              type="text"
              class="form-control"
              v-model="bodyAdd.trainingName"
              placeholder="Training Name" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Method</label>
            <v-select
              v-model="bodyAdd.learningMethod"
              :options="dataTrainingMethod"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Method" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Type</label>
            <v-select
              v-model="bodyAdd.learningType"
              :options="dataTrainingType"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Type" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Price</label>
            <div class="d-flex">
              <v-select
                style="width: 140px; color: gray"
                :options="currencies"
                v-model="bodyAdd.currency"
                class="mr-2" />
              <input
                v-model="bodyAdd.price"
                type="number"
                class="form-control"
                placeholder="Input Price (Numeric)" />
            </div>
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Website</label>
            <input
              type="text"
              class="form-control"
              v-model="bodyAdd.websiteTraining"
              placeholder="Website" />
          </div>
          <div class="col-12 mt-3">
            <label class="form-label">Description</label>
            <textarea
              v-model="bodyAdd.description"
              type="text"
              class="form-control"
              placeholder="Input Description" />
          </div>
        </div>
      </div>
      <b-button class="float-end" variant="primary" @click="createTraining()"
        >Submit
      </b-button>
    </b-modal>
    <!-- Modal Confirmation -->
    <b-modal
      centered
      ref="confirmationModal"
      id="confirmation-modal"
      title="Submit Training"
      @ok="confirmSubmission">
      <div>
        <h5>Will be submitted:</h5>
        <ul v-if="approvedItems && approvedItems.length > 0">
          <li v-for="item in approvedItems" :key="item.id" class="text-success">
            {{ item.training_title }}
          </li>
        </ul>
        <p v-else>No items to be submitted.</p>

        <h5>Will be rejected:</h5>
        <ul v-if="rejectedItems && rejectedItems.length > 0">
          <li v-for="item in rejectedItems" :key="item.id" class="text-danger">
            {{ item.training_title }}
          </li>
        </ul>
        <p v-else>No items to be rejected.</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axiosIns from "@/api/axios";
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";

export default {
  name: "structured",
  data() {
    return {
      lastBusinessUnitFilter: {
      type: null,
      unit: null
    },
      bodySearch: {
        company: "",
        directorate: "",
        division: "",
        department: ""
      },
      bussinessUnit: [],
      bussinessUnit2: [],
      bussinessUnit3: [],
      bussinessUnit4: [],
      dataEmployee: [],
      listKaryawan: [],
      bodyFilter: {},
      nik: "",
      position: "",
      employee: "",
      role: "",
      idTraining: "",
      certificateUrl: "",
      certificateName: "",
      listTabMenu: [],
      inReview: [],
      eventList: [],
      trainingId: "",
      bodyEditEvent: {
        id: "",
        trainingId: "",
        trainingMethod: "",
        location: "",
        price: "",
        quota: ""
      },
      bodyEvent: {
        trainingId: "",
        trainingMethod: "",
        location: "",
        price: "",
        quota: ""
      },
      bodyAdd: {
        competency: "",
        provider: "",
        providerName: "",
        address: "",
        websiteProvider: "",
        contactPerson: "",
        email: "",
        phone: "",
        training: "",
        trainingName: "",
        learningMethod: "",
        learningType: "",
        currency: "IDR",
        price: "",
        websiteTraining: "",
        description: ""
      },
      isEditEvent: false,
      isScheduleModalVisible: false,
      isEnrollModalVisible: false,
      schedule: {
        date: null,
        startTime: null,
        endTime: null
      },
      scheduleList: [],
      bodyEnroll: {
        id: "",
        trainingTitle: "",
        trainingProvider: "",
        trainingMethod: "",
        price: "",
        location: ""
      },
      // originalTrainingMethod: "",
      // originalPrice: "",
      selectedParticipants: [],
      selectedLearning: null,
      searchTimeout: null,
      isModalVisible: false,
      isModalReview: false,
      dataTraining: [],
      dataProvider: [],
      dataCompetency: [],
      dataTrainingMethod: [],
      dataTrainingType: [],
      structuredLearning: [],
      selectedRow: null,
      selectedRows: [],
      approvedItems: [],
      rejectedItems: [],
      currencies: ["USD", "IDR"],
      selectedCurrency: "IDR",
      isLoading: true,
      isEmpty: false,
      currentTab: 0
    };
  },
  computed: {
    formattedParticipants() {
      return this.selectedRow && this.selectedRow.participants
        ? this.selectedRow.participants
        : [];
    }
  },
  watch: {
    employee(newVal, oldVal) {
    if (oldVal && !newVal) {
      console.log("Employee selection cleared - reverting to business unit filter");
      if (this.lastBusinessUnitFilter.type && this.lastBusinessUnitFilter.unit) {
        this.bodyFilter.type = this.lastBusinessUnitFilter.type;
        this.bodyFilter.unit = this.lastBusinessUnitFilter.unit;
      }
      
      // this.nik = null;
      // this.name = null;
      // this.position = null;
    }
  },
    //  selectedRow(newVal) {
    //     if (newVal && newVal.certificate) {
    //       this.updateCertificateUrl();
    //     }
    //   },
    selectedLearning(newVal) {
      if (newVal) {
        this.bodyAdd.training = newVal.id;
      } else {
        this.bodyAdd.training = null;
      }
    },
    "bodyAdd.provider": "fetchTrainingData"
  },
  methods: {
    updateCertificateUrl() {
      this.certificateUrl = `${axiosIns.defaults.baseURL}/certificate/${this.certificateName}`;
    },
    downloadCertificate() {
      let datas = `${axiosIns.defaults.baseURL}/certificate/${this.certificateName}`;
      window.open(datas);
    },
    getEventByHr() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getEventByHr", { id: this.trainingId })
        .then((res) => {
          this.eventList = res.data;
          this.isEmpty = !this.eventList || this.eventList.length === 0;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error get event data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },
    formatSchedule(scheduleList) {
      return scheduleList.map((item) => {
        const date = new Date(item.date);
        const formattedDate = date.toISOString().split("T")[0];
        const formattedStartTime = `${item.startTime}:00+07`;
        const formattedEndTime = `${item.endTime}:00+07`;

        return {
          date: formattedDate,
          start_time: formattedStartTime,
          end_time: formattedEndTime
        };
      });
    },
    showScheduleModal() {
      this.isScheduleModalVisible = true;
    },
    clearScheduleModal() {
      this.schedule = { date: null, startTime: null, endTime: null };
    },
    addSchedule() {
      if (
        this.schedule.date &&
        this.schedule.startTime &&
        this.schedule.endTime
      ) {
        const formattedSchedule = {
          date: this.$moment(this.schedule.date).format("DD MMM YYYY"),
          startTime: this.$moment(this.schedule.startTime).format("HH:mm"),
          endTime: this.$moment(this.schedule.endTime).format("HH:mm")
        };
        this.scheduleList.push(formattedSchedule);
        this.clearScheduleModal();
        this.isScheduleModalVisible = false;
      } else {
        this.$swal("Lengkapi semua kolom");
      }
    },
    removeSchedule(index) {
      this.scheduleList.splice(index, 1);
    },
    updateSelectedParticipants(participants) {
      this.selectedParticipants = participants;
    },
    clearEnrollModal() {
      this.bodyEnroll.trainingTitle = "";
      this.bodyEnroll.trainingProvider = "";
      this.bodyEnroll.trainingMethod = "";
      this.bodyEnroll.location = "";
      this.bodyEnroll.price = "";
      this.bodyEnroll.schedule = [];
      this.bodyEnroll.checkedParticipants = [];
      this.selectedParticipants = [];
      this.scheduleList = [];
      this.selectedRows = [];
    },
    deleteEvent(item) {
      console.log("isinya", item);
      let idEvent = item.id;
      this.$swal({
        title: "Hapus Event",
        text: "Apakah Anda yakin ingin menghapus event yang dipilih?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/deleteTrainingEvent", idEvent)
            .then((response) => {
              console.log("totlol", response);
              this.$swal("Terhapus", "Event berhasil dihapus.", "success");
              this.getEventByHr();
            })
            .catch((error) => {
              this.$swal("Error", "Hapus gagal. Silakan coba lagi.", "error");
            });
        }
      });
    },
    showEditEvent(item) {
      this.bodyEnroll.trainingTitle = item.training_name;
      this.bodyEnroll.trainingProvider = item.training_provider;
      this.isEditEvent = true;
      this.bodyEditEvent.trainingId = this.selectedRow.id;
      this.bodyEditEvent.id = item.id;
      this.bodyEditEvent.trainingMethod = item.training_method;
      this.bodyEditEvent.location = item.location;
      this.bodyEditEvent.price = item.price;
      this.bodyEditEvent.quota = item.quota;
    },
    showCreateEvent() {
      this.bodyEnroll.id = this.selectedRow.id;
      this.selectedParticipants = this.selectedRow.participants.filter(
        (participant) => this.selectedRows.includes(participant.id)
      );
      this.bodyEnroll.trainingTitle = this.selectedRow.training_name;
      this.bodyEnroll.trainingProvider = this.selectedRow.training_provider;
      this.bodyEvent.trainingMethod = this.selectedRow.training_method_id;
      this.bodyEvent.price = this.selectedRow.training_price;
      this.isEnrollModalVisible = true;
    },
    submitEnroll() {
      // console.log("Original schedule list:", this.scheduleList);
      const formattedSchedule = this.formatSchedule(this.scheduleList);
      // console.log("Formatted schedule:", formattedSchedule);
      let requestData = {
        id: this.selectedParticipants.map(
          (participant) => participant.idp_structured_learning_id
        ),
        training_id: this.bodyEnroll.id,
        training_title: this.bodyEnroll.trainingTitle,
        training_provider: this.bodyEnroll.trainingProvider,
        training_method: this.bodyEnroll.trainingMethod,
        location: this.bodyEnroll.location,
        price: Number(this.bodyEnroll.price),
        schedule: formattedSchedule,
        participants: this.selectedParticipants.map(
          (participant) => participant.nik
        )
      };
      this.$store
        .dispatch("myIdp/enrollStructuredLearning", requestData)
        .then((response) => {
          this.$swal(
            "Success",
            "Pendaftaran berhasil dikirim",
            "success"
          );
          this.isEnrollModalVisible = false;
          this.isModalVisible = false;
          this.clearEnrollModal();
          this.getDataIdpPersonal();
        })
        .catch((error) => {
          this.$swal(
            "Error",
            "Pendaftaran belum berhasil dikirim: " +
              (error.response?.data?.message || error.message),
            "error"
          );
        });
    },
    editEvent() {
      const formattedSchedule = this.formatSchedule(this.scheduleList);
      let requestData = {
        id: this.bodyEditEvent.id,
        training_id: this.bodyEditEvent.trainingId,
        training_method: this.bodyEditEvent.trainingMethod,
        location: this.bodyEditEvent.location,
        price: Number(this.bodyEditEvent.price),
        quota: this.bodyEditEvent.quota,
        schedule: formattedSchedule
      };
      this.$store
        .dispatch("myIdp/editTrainingEvent", requestData)
        .then((response) => {
          this.$swal("Success", "Event berhasil diubah", "success");
          this.isEditEvent = false;
          // this.isModalVisible = false;
          this.clearEnrollModal();
          this.getEventByHr();

          this.getDataIdpPersonal();
        })
        .catch((error) => {
          this.$swal(
            "Error",
            "Event belum berhasil diubah: " +
              (error.response?.data?.message || error.message),
            "error"
          );
        });
    },
    submitEvent() {
      const formattedSchedule = this.formatSchedule(this.scheduleList);
      let requestData = {
        training_id: this.bodyEvent.trainingId,
        training_method: this.bodyEvent.trainingMethod,
        location: this.bodyEvent.location,
        price: Number(this.bodyEvent.price),
        quota: this.bodyEvent.quota,
        schedule: formattedSchedule
      };
      this.$store
        .dispatch("myIdp/createTrainingEvent", requestData)
        .then((response) => {
          this.$swal("Success", "Event berhasil dibuat", "success");
          this.isEnrollModalVisible = false;
          // this.isModalVisible = false;
          this.clearEnrollModal();
          this.getEventByHr();

          this.getDataIdpPersonal();
        })
        .catch((error) => {
          this.$swal(
            "Error",
            "Pendaftaran belum berhasil dikirim: " +
              (error.response?.data?.message || error.message),
            "error"
          );
        });
    },
    preselectRows() {
      this.selectedRows = this.selectedRow.participants
        .filter((item) => item.status === "approved")
        .map((item) => item.id);
    },
    resetForm() {
      this.bodyAdd = {
        competency: "",
        provider: "",
        providerName: "",
        address: "",
        website: "",
        contactPerson: "",
        email: "",
        phone: "",
        trainingName: "",
        learningMethod: "",
        learningType: "",
        currency: "",
        price: "",
        description: ""
      };
      this.selectedLearning = null;
      this.$refs.modalTrainingAspiration.hide();
    },
    createTraining() {
      let requestData = {};

      if (this.bodyAdd.provider && this.selectedLearning) {
        requestData = {
          competency: this.bodyAdd.competency,
          provider: this.bodyAdd.provider,
          training: this.bodyAdd.training
        };
      } else if (this.bodyAdd.provider && !this.selectedLearning) {
        requestData = {
          competency: this.bodyAdd.competency,
          provider: this.bodyAdd.provider,
          training: {
            title: this.bodyAdd.trainingName,
            training_type: this.bodyAdd.learningType,
            training_method: this.bodyAdd.learningMethod,
            currency: this.bodyAdd.currency,
            price: this.bodyAdd.price,
            website: this.bodyAdd.websiteProvider,
            description: this.bodyAdd.description
          }
        };
      } else if (!this.bodyAdd.provider && !this.selectedLearning) {
        requestData = {
          competency: this.bodyAdd.competency,
          provider: {
            name: this.bodyAdd.providerName,
            address: this.bodyAdd.address,
            website: this.bodyAdd.websiteProvider,
            contact_person: this.bodyAdd.contactPerson,
            email: this.bodyAdd.email,
            phone: this.bodyAdd.phone
          },
          training: {
            title: this.bodyAdd.trainingName,
            training_type: this.bodyAdd.learningType,
            training_method: this.bodyAdd.learningMethod,
            currency: this.bodyAdd.currency,
            price: this.bodyAdd.price,
            website: this.bodyAdd.websiteTraining,
            description: this.bodyAdd.description
          }
        };
      }
      // console.log("req data => ",requestData)
      this.$store
        .dispatch("myIdp/createStructuredLearning", requestData)
        .then((response) => {
          this.$swal
            .fire({
              icon: "success",
              title: "Success",
              text: "Aspirasi pelatihan berhasil dibuat."
            })
            .then(() => {
              // this.$refs.modalTrainingAspiration.hide();
              this.getDataIdpPersonal();

              this.resetForm();
            });
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Terjadi kesalahan saat membuat aspirasi pelatihan."
          });
        });
    },

    selectTraining(training) {
      if (training) {
        this.bodyAdd.learningMethod = training.training_method;
        this.bodyAdd.learningType = training.training_type;
        this.bodyAdd.currency = training.currency;
        this.bodyAdd.price = training.price;
        this.bodyAdd.trainingName = training.title;
        this.bodyAdd.websiteTraining = training.website;
        this.bodyAdd.description = training.description || "";
      } else {
        this.bodyAdd.learningMethod = null;
        this.bodyAdd.learningType = null;
        this.bodyAdd.currency = "IDR";
        this.bodyAdd.price = null;
        this.bodyAdd.trainingName = "";
        this.bodyAdd.websiteTraining = "";
        this.bodyAdd.description = "";
      }
    },
    async fetchTrainingData(providerId) {
      if (providerId) {
        try {
          const args = {};
          await this.$store.dispatch("trainingProvider/getTrainingByProvider", {
            providerId,
            args
          });
          this.dataTraining =
            this.$store.state.trainingProvider.trainingByProvider;
        } catch (err) {
          console.error(err);
          this.dataTraining = [];
        }
      } else {
        this.dataTraining = [];
      }
    },
    async searchTraining(search) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(async () => {
        if (search.length >= 2 && this.bodyAdd.provider) {
          try {
            await this.$store.dispatch(
              "trainingProvider/getTrainingByProvider",
              {
                providerId: this.bodyAdd.provider,
                search
              }
            );
            this.dataTraining =
              this.$store.state.trainingProvider.trainingByProvider;
          } catch (err) {
            console.error(err);
            this.dataTraining = [];
          }
        } else {
          this.dataTraining = [];
        }
      }, 300);
    },
    selectProvider(selectedProviderId) {
      const selectedProvider = this.dataProvider.find(
        (provider) => provider.id === selectedProviderId
      );
      if (selectedProvider) {
        this.bodyAdd.providerName = selectedProvider.providerName;
        this.bodyAdd.address = selectedProvider.address;
        this.bodyAdd.websiteProvider = selectedProvider.website;
        this.bodyAdd.contactPerson = selectedProvider.contactPerson;
        this.bodyAdd.email = selectedProvider.email;
        this.bodyAdd.phone = selectedProvider.phone;
      }
    },
    viewDetails(row) {
      console.log("rownya", row);
      this.trainingId = row.id;
      this.selectedRow = row;
      this.bodyEvent.trainingId = row.id;
      this.preselectRows();
      this.getEventByHr();
      this.isModalVisible = true;
    },
    viewDetailsReview(row) {
      console.log("rownya", row);
      this.idTraining = row.id;
      this.selectedRow = row;
      this.bodyEvent.trainingId = row.id;
      // this.preselectRows();
      this.certificateName = row.certificate;

      this.updateCertificateUrl();
      this.getEventByHr();
      this.isModalReview = true;
    },
    clearSelectedRow() {
      this.selectedRow = null;
    },
    getProvider() {
      this.$store
        .dispatch("trainingProvider/getTrainingProviders")
        .then((res) => {
          // console.log("provid", res.data);
          this.dataProvider = res.data;
        });
    },
    getCompetency() {
      this.$store.dispatch("competency/getDataCompetencyByNik").then((res) => {
        // console.log("competen", res.data);
        this.dataCompetency = res.data;
      });
    },
    getTrainingMethod() {
      this.$store.dispatch("trainingMethod/getTrainingMethod").then((res) => {
        // console.log("trainMe", res.data);
        this.dataTrainingMethod = res.data;
      });
    },
    getTrainingType() {
      this.$store.dispatch("trainingType/getTrainingType").then((res) => {
        // console.log("trainType", res.data);
        this.dataTrainingType = res.data;
      });
    },
    getDataIdpPersonal() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getIdpHrStructured")
        .then((res) => {
          // console.log("isi res", res);
          this.structuredLearning = res.data;

          this.isEmpty =
            !this.structuredLearning || this.structuredLearning.length === 0;
          // this.preselectRows();
          this.isLoading = false;
          // console.log("structured learning=> ", this.structuredLearning);
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },
    getIdpReview() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getIdpReview", this.bodyFilter)
        .then((res) => {
          // console.log("isi res", res);
          this.inReview = res.data;

          this.isEmpty = !this.inReview || this.inReview.length === 0;
          // this.preselectRows();
          this.isLoading = false;
          // console.log("structured learning=> ", this.structuredLearning);
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },

    initStructuredLearning() {
      this.$store
        .dispatch("myIdp/initIdpStructuredLearning")
        .then((res) => {
          // console.log("isi res", res);
          this.getDataIdpPersonal();
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
        });
    },
    getBadgeStatus(value) {
      if (value === "Completed") {
        return "badge bg-info";
      } else if (value === "Planning") {
        return "badge bg-warning";
      } else if (value === "Assigned") {
        return "badge bg-success";
      } else if (value === "Execution") {
        return "badge bg-danger";
      }
    },
    getBadgeSummary(value) {
      if (value === "Completed") {
        return "badge bg-success";
      } else if (value === "In Progress") {
        return "badge bg-warning";
      }
    },
    getBadgeStatusStructured(value) {
      // const status = value.toLowerCase();
      if (value === "completed") {
        return "badge bg-info";
      } else if (value === "draft") {
        return "badge bg-warning";
      } else if (value === "registered") {
        return "badge bg-secondary";
      } else if (value === "rejected") {
        return "badge bg-danger";
      } else if (value === "submitted") {
        return "badge bg-success";
      } else if (value === "approved") {
        return "badge bg-success";
      } else if (value === "active") {
        return "badge bg-success";
      }
      return "";
    },
    capitalizeStatus(value) {
      if (!value) {
        return null;
      }
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    },
    formatPrice(price, currency = "IDR") {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(price);
    },
    completeReview(item) {
      // console.log("isi review", item)
      // let idTraining = item.id
      this.$swal({
        title: "Selesaikan Pelatihan",
        text: "Apakah Anda yakin ingin menyelesaikan review pelatihan yang dipilih?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/completeReview", this.idTraining)
            .then((response) => {
              this.$swal(
                "Selesai",
                "Pelatihan Anda telah direview.",
                "success"
              );
              this.getIdpReview();
              this.isModalReview = false;
            })
            .catch((error) => {
              this.$swal("Error", "Review gagal. Silakan coba lagi.", "error");
              console.error("Review failed:", error);
            });
        }
      });
    },
    bulkApproved() {
      this.$swal({
        title: "Apakah Anda yakin?",
        text: "Apakah Anda yakin menyetujui data yang berstatus review? ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
        cancelButtonText: "Batal"
      }).then((result) => {
        if (result.isConfirmed) {
          let datas = {
            id: this.inReview.map((item) => item.id)
          };
          if (datas.id.length === 0) {
            this.$swal("Error", "Tidak ada data untuk disetujui", "error");
          } else {
            this.$store
              .dispatch("myIdp/bulkApproved", datas)
              .then((response) => {
                this.$swal(
                  "Selesai",
                  "Persetujuan berhasil",
                  "success"
                );
                this.getIdpReview();
                // this.getDataIdpManager();
              })
              .catch((error) => {
                this.$swal("Error", error.response.error, "error");
                console.error("Review failed:", error);
              });
          }
        }
      });
    },
    confirmSubmission() {
      const approved = this.approvedItems.map((item) => item.id);
      const rejected = this.rejectedItems.map((item) => item.id);
      const cleanedSelectedRows = this.selectedRows.filter(
        (id) => typeof id === "number"
      );
      const reqBody = {
        id: approved,
        reject_id: rejected
      };
      this.$store
        .dispatch("myIdp/submitStructuredLearning", reqBody)
        .then((response) => {
          this.$swal(
            "Terkirim",
            "Pembelajaran Anda telah dikirim.",
            "success"
          );
          this.$refs.confirmationModal.hide();
          this.getDataIdpPersonal();
        });
    },
    submitLearning() {
      const ids = this.selectedRows.map((row) => row.id);
      const requestBody = { id: ids };
      const cleanedSelectedRows = this.selectedRows.filter(
        (id) => typeof id === "number"
      );
      this.approvedItems = this.structuredLearning.filter(
        (item) =>
          cleanedSelectedRows.includes(item.id) && item.status === "draft"
      );
      this.rejectedItems = this.structuredLearning.filter(
        (item) =>
          !cleanedSelectedRows.includes(item.id) && item.status === "draft"
      );
      this.$refs.confirmationModal.show();
    },
    getBusinessUnit() {
      this.$store.dispatch("business/getBusinessUnit").then((res) => {
        this.bussinessUnit = res.data.data;
      });
    },
    onBussinessUnitSelected(now) {
  if (now == "company") {
    if (!this.bodySearch.company) {
      (this.bodySearch.department = ""),
        (this.bodySearch.directorate = ""),
        (this.bodySearch.division = "");
      this.lastBusinessUnitFilter = { type: null, unit: null };
    } else {
      this.bodyFilter.type = "COM";
      this.bodyFilter.unit = this.bodySearch.company;
      // Store the current filter as last business unit filter
      this.lastBusinessUnitFilter = {
        type: "COM",
        unit: this.bodySearch.company
      };
      
      let body = {
        type: "DIR",
        unit: this.bodySearch.company
      };
      let bodyEmployee = {
        type: "COM",
        unit: this.bodySearch.company
      };
      axiosIns
        .post(
          `${axiosIns.defaults.baseURL}/master-data/business-unit-new`,
          body
        )
        .then((resp) => {
          this.bussinessUnit2 = resp.data.data;
        });
      axiosIns
        .post(
          `${axiosIns.defaults.baseURL}/master-data/business-unit-new/employee`,
          bodyEmployee
        )
        .then((resp) => {
          this.listKaryawan = resp.data.data;
        });
    }
  } else if (now == "dir") {
    if (!this.bodySearch.directorate) {
      (this.bodySearch.department = ""), (this.bodySearch.division = "");
      // Revert to company level if directorate is cleared
      if (this.bodySearch.company) {
        this.bodyFilter.type = "COM";
        this.bodyFilter.unit = this.bodySearch.company;
        this.lastBusinessUnitFilter = {
          type: "COM",
          unit: this.bodySearch.company
        };
      }
    } else {
      this.bodyFilter.type = "DIR";
      this.bodyFilter.unit = this.bodySearch.directorate;
      // Store the current filter as last business unit filter
      this.lastBusinessUnitFilter = {
        type: "DIR",
        unit: this.bodySearch.directorate
      };
      
      let body = {
        type: "DIV",
        unit: this.bodySearch.directorate
      };
      let bodyEmployee = {
        type: "DIR",
        unit: this.bodySearch.directorate
      };
      axiosIns
        .post(
          `${axiosIns.defaults.baseURL}/master-data/business-unit-new`,
          body
        )
        .then((resp) => {
          this.bussinessUnit3 = resp.data.data;
        });
      axiosIns
        .post(
          `${axiosIns.defaults.baseURL}/master-data/business-unit-new/employee`,
          bodyEmployee
        )
        .then((resp) => {
          this.listKaryawan = resp.data.data;
        });
    }
  } else if (now == "div") {
    if (!this.bodySearch.division) {
      this.bodySearch.department = "";
      // Revert to directorate level if division is cleared
      if (this.bodySearch.directorate) {
        this.bodyFilter.type = "DIR";
        this.bodyFilter.unit = this.bodySearch.directorate;
        this.lastBusinessUnitFilter = {
          type: "DIR",
          unit: this.bodySearch.directorate
        };
      }
    } else {
      this.bodyFilter.type = "DIV";
      this.bodyFilter.unit = this.bodySearch.division;
      // Store the current filter as last business unit filter
      this.lastBusinessUnitFilter = {
        type: "DIV",
        unit: this.bodySearch.division
      };
      
      let body = {
        type: "DEP",
        unit: this.bodySearch.division
      };
      let bodyEmployee = {
        type: "DIV",
        unit: this.bodySearch.division
      };
      axiosIns
        .post(
          `${axiosIns.defaults.baseURL}/master-data/business-unit-new`,
          body
        )
        .then((resp) => {
          console.log(resp.data.data);
          this.bussinessUnit4 = resp.data.data;
        });
      axiosIns
        .post(
          `${axiosIns.defaults.baseURL}/master-data/business-unit-new/employee`,
          bodyEmployee
        )
        .then((resp) => {
          this.listKaryawan = resp.data.data;
        });
    }
  } else if (now == "dept") {
    this.bodyFilter.type = "DEP";
    this.bodyFilter.unit = this.bodySearch.department;
    // Store the current filter as last business unit filter
    this.lastBusinessUnitFilter = {
      type: "DEP",
      unit: this.bodySearch.department
    };
    
    let bodyEmployee = {
      type: "DEP",
      unit: this.bodySearch.department
    };
    axiosIns
      .post(
        `${axiosIns.defaults.baseURL}/master-data/business-unit-new/employee`,
        bodyEmployee
      )
      .then((resp) => {
        this.listKaryawan = resp.data.data;
      });
  }
},
selectEmployee() {
  if (this.employee) {
    const e = this.employee; 
    console.log("nik", e);
    
    this.bodyFilter.type = "NIK";
    this.nik = e.employee_nik;
    this.bodyFilter.unit = this.nik;
    this.name = e.employee_name;
    this.position = e.position_title;
    
    console.log(this.bodyFilter);
  } else {
    console.log("No employee selected - reverting to business unit filter");
    if (this.lastBusinessUnitFilter.type && this.lastBusinessUnitFilter.unit) {
      this.bodyFilter.type = this.lastBusinessUnitFilter.type;
      this.bodyFilter.unit = this.lastBusinessUnitFilter.unit;
    } else {
      // this.bodyFilter.type = null;
      // this.bodyFilter.unit = null;
    }
    
    // this.nik = null;
    // this.name = null;
    // this.position = null;
  }
  
  this.getIdpReview();
},
  },
  mounted() {
    this.getDataIdpPersonal();
    this.getIdpReview();
    this.getBusinessUnit();
    //  this.$root.$on("roles", (body) => {
    //   this.role = body;
    //   console.log("bodi", body);
    // });
    this.role = localStorage.getItem("roles");
    // console.log("bodi", this.role);
    // this.getCompetency();
    // this.getProvider();
    this.getTrainingMethod();
    // this.getTrainingType();
    const listMenu = JSON.parse(localStorage.getItem("listMenu") || []);
    const currentPath = window.location.pathname; // Path dari URL saat ini
    const menu = listMenu.find(
      (menu) =>
        menu.link === String(currentPath) ||
        menu.children.some((child) => child.link === String(currentPath))
    );
    this.listTabMenu = menu;
  }
};
</script>

<style>
.table-responsive::-webkit-scrollbar {
  display: none; /* For Chrome, Safari, and Opera */
}
.table-responsive {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
